import { useState } from "react";
import * as PR from "../../../../prime-react/index";


const EventMetaTable = ({ dataList, footerGroup, header, graphId }) => {
    const [sortFiled, setSortFiled] = useState('netGGR');
    const [sortOrder, setSortOrder] = useState(-1);
    return (
        <>
            <PR.DataTable value={dataList} stripedRows className="data-table" footerColumnGroup={footerGroup}
                rowClassName={(rowData) => { return rowData.id === graphId ? 'selected-tr' : ''; }} 
                sortField={sortFiled}
                sortOrder={sortOrder}
                onSort={({sortField:F, sortOrder: v}) => { setSortFiled(F); setSortOrder(v);}}
                >
                <PR.Column field="name" header={header} style={{ width: "40%" }} />
                <PR.Column field="totalStakeFormat" header="Total Stake" sortable sortField="totalStake" sortableDisabled={!dataList?.length}/>
                <PR.Column field="netGGRFormat" header="Net GGR" sortable sortField="netGGR" sortableDisabled={!dataList?.length}/>
                {/* <PR.Column field="ticketSoldFormat" header="Ticket Sold" sortable /> */}
            </PR.DataTable>
        </>
    )
}

export default EventMetaTable;